import { Navigate, Route, Routes, useLocation } from 'react-router';
import { useSession } from '@/lib/session';
import Login from '@/pages/Login';
import ConcoursTest from '@/pages/ConcoursTest';
import Home from '@/pages/Home';
import Comptoir from '@/pages/Comptoir';
import Consultation from '@/pages/Consultation';
import Catalogue from '@/pages/Catalogue';
import NouvelleCommande from '@/pages/NouvelleCommande';
import Commande from '@/pages/Commande';
import AdminLayout from '@/pages/admin/AdminLayout';
import Dashboard from '@/pages/admin/Dashboard';
import Orders from '@/pages/admin/Orders';
import Customers from '@/pages/admin/Customers';
import Rewards from '@/pages/admin/Rewards';
import Claims from '@/pages/admin/Claims';
import Settings from '@/pages/admin/Settings';
import Imports from '@/pages/admin/Imports';
import Export from '@/pages/admin/Export';
import Lines from '@/pages/admin/Lines';
import Promotions from '@/pages/admin/Promotions';
import Reps from '@/pages/admin/Reps';

export default function App() {
  const { session, isLoading, isError } = useSession();
  const location = useLocation();

  // Page concours PUBLIQUE : les participants (clients) n'ont pas de compte
  // SuperShow — on la rend avant toute vérification de session.
  if (location.pathname === '/concour') return <ConcoursTest />;

  if (isLoading) {
    return (
      <div className="text-muted-foreground flex min-h-full items-center justify-center">
        Chargement…
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex min-h-full flex-col items-center justify-center gap-3 p-8 text-center">
        <p className="text-destructive font-medium">Serveur injoignable.</p>
        <p className="text-muted-foreground text-sm">
          Vérifiez la connexion réseau, puis rechargez la page.
        </p>
      </div>
    );
  }

  if (!session) return <Login />;

  // Rôle comptoir : uniquement la distribution des cadeaux, rien d'autre.
  if (session.user.role === 'COMPTOIR') {
    return (
      <>
        <div aria-hidden className="app-damier pointer-events-none fixed inset-0 -z-10" />
        <Comptoir session={session} />
      </>
    );
  }

  const isAdmin = session.user.role === 'ADMIN';
  // REP_JEUX (« Compte Jeux ») a les mêmes accès qu'un représentant super.
  const isSuperRep = session.user.role === 'REP_SUPER' || session.user.role === 'REP_JEUX';

  return (
    <>
      {/* Fond damier de la marque, posé derrière toutes les pages authentifiées
          (l'écran de connexion, rendu plus haut, garde son affiche). Couche fixe :
          le motif ne défile pas. */}
      <div aria-hidden className="app-damier pointer-events-none fixed inset-0 -z-10" />
      <Routes>
      {/* L'admin supervise : son accueil est le tableau de bord, pas l'écran de
          prise de commande. Les reps gardent l'accueil de vente. */}
      <Route
        path="/"
        element={isAdmin ? <Navigate to="/admin" replace /> : <Home session={session} />}
      />
      <Route path="/catalogue" element={<Catalogue session={session} />} />
      <Route path="/order/new" element={<NouvelleCommande />} />
      <Route path="/order/:id" element={<Commande />} />
      {/* Représentant super : consultation cadeaux + historique commandes client. */}
      {isSuperRep && <Route path="/consultation" element={<Consultation />} />}

      {/* Garde côté client pour le confort. La vraie garde est sur /api/admin. */}
      {isAdmin && (
        <Route path="/admin" element={<AdminLayout session={session} />}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="orders" element={<Orders />} />
          <Route path="customers" element={<Customers />} />
          <Route path="rewards" element={<Rewards />} />
          <Route path="claims" element={<Claims />} />
          <Route path="imports" element={<Imports />} />
          <Route path="lines" element={<Lines />} />
          <Route path="catalogue" element={<Catalogue session={session} embedded />} />
          <Route path="promotions" element={<Promotions />} />
          <Route path="reps" element={<Reps />} />
          <Route path="export" element={<Export />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      )}

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}
